const callCenterRest = [
  // 查询货源记录
  {
    url: '/call-center/wb/callCenter/searchGoods',
    coverFields: [
      {
        field: 'goodsList',
        keys: ['shipperTel', 'telephone']
      }
    ]
  },
  // 查询货源记录 新
  {
    url: '/client-portrait-app/searchGoods',
    coverFields: [
      {
        field: 'goodsList',
        keys: ['shipperTel', 'telephone']
      }
    ]
  },
  {
    url: '/call-center/callCenter/searchGoods',
    coverFields: [
      {
        field: 'goodsList',
        keys: ['shipperTel', 'telephone']
      }
    ]
  },
  {
    url: '/call-center/callCenter/historyCall',
    coverFields: [
      {
        field: 'callList',
        keys: ['customerTelephone']
      }
    ]
  },
  // 查询保险理赔记录
  {
    url: '/call-center/wb/callCenter/queryInsuranceClaims',
    coverFields: [
      {
        field: 'content',
        keys: ['reporterTel', 'consignorTel', 'carNumber']
      }
    ]
  },
  // 查询保险理赔记录 新
  {
    url: '/client-portrait-app/insurance/queryInsuranceClaims',
    coverFields: [
      {
        field: 'content',
        keys: ['reporterTel', 'consignorTel', 'carNumber']
      }
    ]
  },
  // 查询保险理赔记录 ?
  {
    url: '/call-center/callCenter/queryInsuranceClaims',
    coverFields: [
      {
        field: 'content',
        keys: ['reporterTel', 'consignorTel', 'carNumber']
      }
    ]
  },
  // 5
  // {
  //   url: '/call-center/wb/callCenter/historyWorkOrder',
  //   coverFields: [
  //     {
  //       field: 'orderList',
  //       keys: ['customerPhone', 'defendantTel']
  //     }
  //   ]
  // },
  // {
  //   url: '/call-center/callCenter/historyWorkOrder',
  //   coverFields: [
  //     {
  //       field: 'orderList',
  //       keys: ['customerPhone', 'defendantTel']
  //     }
  //   ]
  // },
  // 6
  // {
  //   url: '/call-center/wb/callCenter/searchCase',
  //   coverFields: [
  //     {
  //       field: 'callList',
  //       keys: ['customerTelephone', 'customerName']
  //     }
  //   ]
  // },
  // {
  //   url: '/call-center/callCenter/searchCase',
  //   coverFields: [
  //     {
  //       field: 'callList',
  //       keys: ['customerTelephone', 'customerName']
  //     }
  //   ]
  // },
  // 7
  // {
  //   url: '/call-center/wb/callCenter/queryEnsureClaimList',
  //   coverFields: [
  //     {
  //       field: 'content',
  //       keys: ['reportUserPhone', 'sideUserPhone', 'reportUserName', 'sideUserName']
  //     }
  //   ]
  // },
  {
    url: '/call-center/callCenter/queryEnsureClaimList',
    coverFields: [
      {
        field: 'content',
        keys: ['reportUserPhone', 'sideUserPhone', 'reportUserName', 'sideUserName']
      }
    ]
  },
  {
    // 资产信息ETC充值记录
    url: '/call-center/wb/callCenter/customerEtcRechargeLog',
    coverFields: [
      {
        field: 'etcRechargeLogs',
        keys: ['vanNumber', 'commissionAmount', 'balance ', 'depositAmount', 'operateName', 'blance', 'etcCard']
      }
    ]
  },
  {
    // 资产信息ETC充值记录 新
    url: '/client-portrait-app/etc/customerEtcRechargeLog',
    coverFields: [
      {
        field: 'etcRechargeLogs',
        keys: ['vanNumber', 'commissionAmount', 'balance ', 'depositAmount', 'operateName', 'blance', 'etcCard']
      }
    ]
  },
  {
    url: '/call-center/callCenter/customerEtcRechargeLog',
    coverFields: [
      {
        field: 'etcRechargeLogs',
        keys: ['vanNumber']
      }
    ]
  },
  // 资产信息ETC消费记录
  {
    url: '/call-center/wb/callCenter/customerEtcUseLog',
    coverFields: [
      {
        field: 'etcUseLogs',
        keys: [
          'vanNumber',
          'cardNo',
          'consumeMoney',
          'balance',
          'balanceStr',
          'tradeMoney',
          'tradeMoneyStr',
          'etcCardTradeMoney',
          'realConsumeMoney'
        ]
      }
    ]
  },
  {
    url: '/call-center/callCenter/customerEtcUseLog',
    coverFields: [
      {
        field: 'etcUseLogs',
        keys: ['vanNumber', 'cardNo']
      }
    ]
  },
  // 资产信息ETC退费记录
  {
    url: '/call-center/wb/callCenter/queryEtcRefundInfo',
    coverFields: [
      {
        field: 'etcRefundInfoDTOS',
        keys: [
          'idNo',
          'vanNum',
          'phone',
          'bankCardNo',
          'realAmount',
          'etcCardBalance',
          'thirdRealAmount',
          'cardNo',
          'bankBranchName',
          'bankName',
          'bankUserName',
          'userName'
        ],
        onlyMask: ['phone']
      }
    ]
  },
  // 资产信息ETC退费记录 新
  {
    url: '/client-portrait-app/etc/queryEtcRefundInfo	',
    coverFields: [
      {
        field: 'etcRefundInfoDTOS',
        keys: [
          'idNo',
          'vanNum',
          'phone',
          'bankCardNo',
          'realAmount',
          'etcCardBalance',
          'thirdRealAmount',
          'cardNo',
          'bankBranchName',
          'bankName',
          'bankUserName',
          'userName'
        ],
        onlyMask: ['phone']
      }
    ]
  },
  // 资产信息-ETC开卡记录
  {
    url: '/call-center/wb/callCenter/customerEtcOpenInfo',
    coverFields: [
      {
        field: 'results',
        keys: ['vanNumber', 'phone', 'credentialNo', 'cardUserName', 'userName', 'cardName', 'cardFaceNumber'],
        onlyMask: ['phone']
      }
    ]
  },
  // 资产信息-ETC开卡记录 新
  {
    url: '/client-portrait-app/etc/customerEtcOpenInfo',
    coverFields: [
      {
        field: 'results',
        keys: ['vanNumber', 'phone', 'credentialNo', 'cardUserName', 'userName', 'cardName', 'cardFaceNumber'],
        onlyMask: ['phone']
      }
    ]
  },
  {
    url: '/call-center/callCenter/customerEtcOpenInfo',
    coverFields: [
      {
        field: 'results',
        keys: ['vanNumber', 'phone', 'credentialNo']
      }
    ]
  },
  // 14
  {
    url: '/call-center/callCenter/customerEtcCancelInfo',
    coverFields: [
      {
        field: 'results',
        keys: ['vanNumber', 'phone', 'credentialNo']
      }
    ]
  },
  // 资产信息-ETC销卡记录
  {
    url: '/call-center/wb/callCenter/customerEtcCancelInfo',
    coverFields: [
      {
        field: 'results',
        keys: [
          'vanNumber',
          'phone',
          'credentialNo',
          'userName',
          'cardName',
          'cardFaceNumber',
          'cardUserName',
          'cardNo'
        ],
        onlyMask: ['phone']
      }
    ]
  },
  // 资产信息-ETC销卡记录 新
  {
    url: '/client-portrait-app/etc/customerEtcCancelInfo',
    coverFields: [
      {
        field: 'results',
        keys: [
          'vanNumber',
          'phone',
          'credentialNo',
          'userName',
          'cardName',
          'cardFaceNumber',
          'cardUserName',
          'cardNo'
        ],
        onlyMask: ['phone']
      }
    ]
  },
  // 16. 资产信息-油卡消费记录
  {
    url: '/call-center/wb/freight/oil/card/spendRecord',
    coverFields: [
      {
        field: 'rows',
        keys: ['driverUserPhone', 'oilOriginAmount', 'payAmount', 'driverUserName']
      }
    ]
  },
  // 16. 资产信息-油卡消费记录 新
  {
    url: '/client-portrait-app/freight/oil/card/spendRecord',
    coverFields: [
      {
        field: 'rows',
        keys: ['driverUserPhone', 'oilOriginAmount', 'payAmount', 'driverUserName']
      }
    ]
  },
  // 17. 资产信息-油卡充值记录
  {
    url: '/call-center/wb/freight/oil/card/allocateRecord',
    coverFields: [
      {
        field: 'rows',
        keys: ['driverUserPhone', 'driverUserName', 'allocateAmount', 'user']
      }
    ]
  },
  // 17. 资产信息-油卡充值记录 新
  {
    url: '/client-portrait-app/freight/oil/card/allocateRecord',
    coverFields: [
      {
        field: 'rows',
        keys: ['driverUserPhone', 'driverUserName', 'allocateAmount', 'user']
      }
    ]
  },
  // {
  //   url: '/call-center/callCenter/getLoanStatus'
  // },
  // 19
  // 分期还款明细查询
  {
    url: '/call-center/wb/callCenter/getInstallmentDetail',
    coverFields: ['repayAmount', 'repayPrincipal', 'interest', 'fee', 'rolloverFee', 'paidAmount', 'penalty']
  },
  // 分期还款明细查询 新
  {
    url: '/client-portrait-app/asset/getInstallmentDetail',
    coverFields: ['repayAmount', 'repayPrincipal', 'interest', 'fee', 'rolloverFee', 'paidAmount', 'penalty']
  },
  // {
  //   url: '/call-center/callCenter/getInstallmentDetail'
  // },
  // 20
  // 司机贷/白条贷款记录查询
  {
    url: '/call-center/wb/callCenter/getLoanRecord',
    coverFields: [
      {
        field: 'currentPageData',
        keys: [
          'amount',
          'fee',
          'unpaidPrincipal',
          'paidPrincipal',
          'totalInterest',
          'unpaidGuaranteeFee',
          'unpaidInterest',
          'paidInterest'
        ]
      }
    ]
  },
  // 司机贷/白条贷款记录查询 新
  {
    url: '/client-portrait-app/asset/getLoanRecord',
    coverFields: [
      {
        field: 'currentPageData',
        keys: [
          'amount',
          'fee',
          'unpaidPrincipal',
          'paidPrincipal',
          'totalInterest',
          'unpaidGuaranteeFee',
          'unpaidInterest',
          'paidInterest'
        ]
      }
    ]
  },
  // {
  //   url: '/call-center/callCenter/getLoanRecord'
  // },
  // 21
  // {
  //   url: '/call-center/wb/callCenter/searchOrder',
  //   coverFields: [
  //     {
  //       field: 'businessList',
  //       keys: ['driverName', 'driverTel', 'licenceNo', 'shipperName', 'shipperTel']
  //     }
  //   ]
  // },
  {
    url: '/client-portrait-app/wb/callCenter/searchOrder',
    coverFields: [
      {
        field: 'businessList',
        keys: ['driverName', 'driverTel', 'licenceNo', 'shipperName', 'shipperTel', 'techServiceFeeAmount']
      }
    ]
  },
  // 22 根据订单号获取订单信息
  {
    url: '/call-center/wb/callCenter/orderInfo',
    coverFields: ['driverName', 'shipperName', 'shipperTel', 'driverTel', 'licenceNo'],
    onlyMask: ['shipperTel', 'driverTel']
  },
  // 22 根据订单号获取订单信息 新
  {
    url: '/client-portrait-app/order/orderInfo',
    coverFields: ['driverName', 'shipperName', 'shipperTel', 'driverTel', 'licenceNo'],
    onlyMask: ['shipperTel', 'driverTel']
  },
  // 23
  {
    url: '/call-center/wb/queryCommentsByOrderId',
    coverFields: ['commenterTel', 'commentedTel', 'commenterName', 'commentedName']
  },
  // 23 查询运单评论记录 新
  {
    url: '/client-portrait-app/order/queryCommentsByOrderId',
    coverFields: ['commenterTel', 'commentedTel', 'commenterName', 'commentedName']
  },
  // {
  //   url: '/call-center/callCenter/queryCommentsByOrderId',
  //   coverFields: ['commenterTel', 'commentedTel', 'commenterName', 'commentedName']
  // },
  // 25 保险购买记录查询
  {
    url: '/call-center/wb/queryHcbInsuranceList',
    coverFields: [
      {
        field: 'hcbInsuranceDetailList',
        keys: ['applicantName', 'insuredName', 'premium']
      }
    ]
  },
  // 保险购买记录查询 新
  {
    url: '/client-portrait-app/insurance/queryHcbInsuranceList',
    coverFields: [
      {
        field: 'hcbInsuranceDetailList',
        keys: ['applicantName', 'insuredName', 'premium']
      }
    ]
  },
  // 27.资产信息钱包流水
  {
    url: '/call-center/wb/payAccount/queryCashList',
    coverFields: [
      {
        field: 'cashFlowDTO',
        keys: ['bankCard', 'tradeAmount', 'inOut', 'subAmount']
      }
    ]
  },
  // 27.资产信息钱包流水 新
  {
    url: '/client-portrait-app/asset/payAccount/queryCashList',
    coverFields: [
      {
        field: 'cashFlowDTO',
        keys: ['bankCard', 'tradeAmount', 'inOut', 'subAmount']
      }
    ]
  },
  // 28
  {
    url: '/call-center/wb/payAccount/queryPayAuthInfo',
    coverFields: ['cellphone', 'IDCard', 'bankNo']
  },
  // 29
  // {
  //   url: '/call-center/wb/callCenter/getTotalPoints',
  //   coverFields: []
  // },
  // 30
  // {
  //   url: 'call-center/wb/callCenter/queryPointsDetail',
  //   coverFields: [
  //     {
  //       field: 'rows',
  //       keys: ['points']
  //     }
  //   ]
  // },
  // 积分兑换记录
  {
    url: 'call-center/wb/callCenter/userExchangeLog',
    coverFields: [
      {
        field: 'rows',
        keys: ['payPersonPhone', 'contactNumber', 'deliveryAddress', 'exchangePoints', 'orderAmount']
      }
    ]
  },
  // 积分兑换记录 新
  {
    url: 'client-portrait-app/userPoint/userExchangeLog',
    coverFields: [
      {
        field: 'rows',
        keys: ['payPersonPhone', 'contactNumber', 'deliveryAddress', 'exchangePoints', 'orderAmount']
      }
    ]
  },
  // {
  //   url: 'call-center/wb/callCenter/sendSms',
  //   coverFields: [
  //     {
  //       field: 'data',
  //       keys: []
  //     }
  //   ]
  // },
  {
    url: 'call-center/wb/callCenter/customerInfo',
    coverFields: ['idCard', 'detailPlace', 'registerTelephone', 'licenceNo', 'companyPlace']
  },
  {
    url: 'call-center/callCenter/customerInfo',
    coverFields: ['idCard', 'detailPlace', 'registerTelephone', 'licenceNo', 'companyPlace']
  },
  {
    url: 'client-portrait-app/user/customerInfo',
    coverFields: ['idCard', 'detailPlace', 'registerTelephone', 'licenceNo', 'companyPlace']
  },
  // {
  //   url: 'call-center/wb/callCenter/customerVanGoghInfo',
  //   coverFields: [
  //     {
  //       field: 'data',
  //       keys: []
  //     }
  //   ]
  // },
  // {
  //   url: 'call-center/wb/callCenter/creditScoreTxnList', // 信誉变化记录
  //   coverFields: [
  //     {
  //       field: 'data',
  //       keys: []
  //     }
  //   ]
  // },
  // {
  //   url: 'call-center/callCenter/creditScoreTxnList',
  //   coverFields: [
  //     {
  //       field: 'data',
  //       keys: []
  //     }
  //   ]
  // },
  {
    url: 'callCenter/logOffRecord/',
    coverFields: [
      {
        field: 'operationLogDTO',
        keys: ['telephone']
      }
    ]
  },
  // {
  //   url: 'call-center/wb/queryChangeMobileLog', // 手机号修改记录，以前有
  //   coverFields: [
  //     {
  //       field: 'data',
  //       keys: ['oldTelephone', 'newTelephone']
  //     }
  //   ]
  // },
  // {
  //   url: 'call-center/wb/query/frozenReason',
  //   coverFields: [
  //     {
  //       field: 'data',
  //       keys: []
  //     }
  //   ]
  // },
  {
    url: 'call-center/wb/query/userVerifyAndBankCard', // 认证信息
    coverFields: ['certNum', 'phoneNum', 'bankCardNo']
  },
  {
    url: 'call-center/wb/query/userVerifyRecord', // 认证记录
    coverFields: ['tellPhone', 'certNum']
  },
  // {
  //   url: 'call-center/callCenter/separateCalls', // 以前有，少了一个字段
  //   coverFields: [
  //     {
  //       field: 'callList',
  //       keys: ['customerTelephone']
  //     }
  //   ]
  // },
  // {
  //   url: 'call-center/callCenter/completedOrder', // 完成业务单列表, 以前有，少了一个字段
  //   coverFields: [
  //     {
  //       field: 'callList',
  //       keys: ['customerTelephone']
  //     }
  //   ]
  // },
  // {
  //   url: 'call-center/callCenter/transferedOrder', // 完成业务单列表, 以前有，少了一个字段
  //   coverFields: [
  //     {
  //       field: 'callList',
  //       keys: ['customerTelephone']
  //     }
  //   ]
  // },
  {
    url: 'crm-access/record/orderDetail',
    coverFields: ['telephone', 'userTelephone']
  },
  {
    url: 'crm-access/record/getDetailByCallId',
    coverFields: ['telephone', 'userTelephone']
  },
  // {
  //   url: 'call-center/callCenter/saveOrder',
  //   coverFields: [
  //     {
  //       field: 'data',
  //       keys: []
  //     }
  //   ]
  // },
  // {
  //   url: 'call-center/server/callOrderList',  // 服务单中心，以前有，少了一个字段
  //   coverFields: [
  //     {
  //       field: 'callList',
  //       keys: ['customerTelephone']
  //     }
  //   ]
  // },
  {
    url: 'crm-access/record/callOrderListPost',
    coverFields: [
      {
        field: 'callList',
        keys: ['customerTelephone', 'customerName']
      }
    ]
  },
  // {
  //   url: 'call-center/callCenter/searchCustomer', // 切换账户搜索用户列表，以前有，少了一个字段
  //   coverFields: [
  //     {
  //       field: 'customers',
  //       keys: ['idCard']
  //     }
  //   ]
  // },
  // {
  //   url: 'call-center/callCenter/queryMobileArea',
  //   coverFields: [
  //     {
  //       field: 'data',
  //       keys: []
  //     }
  //   ]
  // }
  {
    url: '/callcenter-app/detail/callInfos',
    coverFields: [
      {
        field: 'results',
        keys: ['tel']
      }
    ]
  },
  // 企业信息
  {
    url: '/call-center/callCenter/enterpriseInfo',
    coverFields: ['branchCompanyName', 'companyName']
  },
  // 企业信息 新
  {
    url: '/client-portrait-app/user/enterpriseInfo',
    coverFields: ['branchCompanyName', 'companyName']
  },
  // 订单记录
  {
    url: '/wb/pboss/order/list',
    coverFields: [
      {
        field: 'results',
        keys: ['totalAmount', 'paidAmount']
      }
    ]
  },
  // 订单记录 新
  {
    url: '/order/pboss/order/list',
    coverFields: [
      {
        field: 'results',
        keys: ['totalAmount', 'paidAmount']
      }
    ]
  }
]

export default callCenterRest
